<script>
import LeftSubmenu from './LeftSubmenu';
import LeftMenuItem from './LeftMenuItem';

export default {
  functional: true,
  render(h, { props, data, scopedSlots }) {
    return h(props.item.children?.length ? LeftSubmenu : LeftMenuItem, {
      ...data,
      scopedSlots
    });
  }
};
</script>
